'use client';

import React from 'react';

const GOLD_ACCENT = '#faaf40';
const SHADOW_GOLD = 'rgba(250, 175, 64, 0.6)';

const facilityImages = [
  { src: '/cardio-performance.jpg', alt: 'Cardio Area' },
  { src: '/ems-sculpt.jpg', alt: 'EMS SCULPT' },
  { src: '/ems-suits.jpg', alt: 'EMS SUIT' },
  { src: '/pilates-reformer.jpg', alt: 'Pilates' },
];

export default function FacilitiesSection() {
  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12 sm:mb-16">
          <h2 
            className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4" 
            style={{ color: GOLD_ACCENT, textShadow: `0 0 10px ${SHADOW_GOLD}` }}
          >
            State-of-the-Art Facilities
          </h2>
          <p className="text-base sm:text-lg max-w-2xl mx-auto text-gray-400">
            Designed for performance and recovery.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {facilityImages.map((img, index) => (
            <div
              key={index}
              // Changed h-96 to responsive heights: shorter on mobile (h-64), taller on desktop (h-96)
              className="relative h-64 sm:h-80 lg:h-96 rounded-lg overflow-hidden group shadow-lg cursor-pointer"
              style={{ border: `2px solid ${GOLD_ACCENT}` }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:brightness-75"
              />
              
              {/* Overlay: Slightly darker on mobile by default so text pops without hover */}
              <div className="absolute inset-0 bg-black/40 lg:bg-black/25 lg:group-hover:bg-black/40 transition-all duration-300" />
              
              {/* Title: Always visible on Mobile/Tablet, fades in on Desktop hover */}
              <h3 
                className="
                  absolute bottom-4 left-4 text-xl sm:text-2xl font-bold text-white 
                  transition-all duration-300 
                  translate-y-0 opacity-100 
                  lg:translate-y-4 lg:opacity-0 lg:group-hover:translate-y-0 lg:group-hover:opacity-100
                "
                style={{ textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}
              >
                {img.alt}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}